import {
  SingleSlotDefinition,
  SlotLineDefinition,
  SlotPairDefinition,
  SlotType
} from './SlotDefinition';
import { ArticleInstanceId, SlotInstanceId } from './Uuid';

export interface BaseSlot {
  id: SlotInstanceId;
  parentId?: ArticleInstanceId;
  blockedBy?: ArticleInstanceId;
}

export interface SingleSlot extends BaseSlot {
  type: SlotType.SINGLE;
  definition: SingleSlotDefinition;
  childId?: ArticleInstanceId;
}

export interface SlotPair extends BaseSlot {
  type: SlotType.PAIR;
  definition: SlotPairDefinition;
  childId?: ArticleInstanceId;
}

export interface SlotLine extends BaseSlot {
  type: SlotType.LINE;
  definition: SlotLineDefinition;
  children: SlotLineChild[];
}

export interface SlotLineChild {
  id: ArticleInstanceId;
  position: number;
}

export function isSlotLine(slot: Slot): slot is SlotLine {
  return slot.type === SlotType.LINE;
}

export type Slot = SingleSlot | SlotPair | SlotLine;
